import { Stack } from '@mui/material';
import { useContext } from 'react';
import { ReviewCasesContext } from '../../../context/review/ReviewCasesContext';
import { ReviewSessionsContext } from '../../../context/review/ReviewSessionsContext';
import { SearchContext } from '../../../context/searchContext';
import { getClientCaseSessions } from '../../ClientsTab/ClientsTable';
import ReviewCaseCard from './ReviewCaseCard';

const ReviewCasesTable = () => {
    const { reviewCases, filteredCases } = useContext(ReviewCasesContext);
    const { reviewSessions } = useContext(ReviewSessionsContext);
    const { caseInfoSubstring } = useContext(SearchContext);

    const casesDisplayed = caseInfoSubstring && filteredCases ? filteredCases : reviewCases;

    return (
        <Stack spacing={1.5} sx={{ p: 1.5 }}>
            {casesDisplayed.map((reviewCase) => (
                <ReviewCaseCard
                    key={reviewCase.id}
                    reviewCase={reviewCase}
                    sessionCount={getClientCaseSessions(reviewSessions, reviewCase).length}
                />
            ))}
        </Stack>
    );
};

export default ReviewCasesTable;